import React from "react";
import { Segment } from "semantic-ui-react";
import { strings } from "../localization/strings";

interface IErrorPageProps {}

export const ErrorPage: React.FC<IErrorPageProps> = (props) => {
  return <Segment>{strings.errorPageMessage.text()}</Segment>;
};
